import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class UnidadMedidaService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerRubros(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            unidad_medida {
              obtenerTodos(paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  registros {
                    codigo
                    nombre
                    activo
                  }
                  totalPaginas
                  totalRegistros
                }
              }
            }
          }
        `,
            variables: {
                variables: inputParams,
                fetchPolicy: 'no-cache',
            },
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.unidad_medida.obtenerTodos;
            callback({ mensajes, respuesta });
        });
    }
    obtenerSegunFiltro(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad:unidad_medidaInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            unidad_medida {
              obtenerSegunFiltro(filtro:{exacto:$entidad}, paginaActual:$paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  registros {
                    codigo
                    nombre
                    activo
                  }
                  totalPaginas
                  totalRegistros
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.unidad_medida.obtenerSegunFiltro;
            callback({ mensajes, respuesta });
        });
    }
    guardar(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        mutation ($entidad: unidad_medidaInputType) {
          unidad_medida {
            guardar(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                nombre
                activo
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.unidad_medida.guardar;
            callback({ mensajes, respuesta });
        });
    }
    cambiaEstado(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        mutation ($entidad: unidad_medidaInputType) {
          unidad_medida {
            cambiaEstado(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                activo
              }
            }
          }
        }        
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.unidad_medida.cambiaEstado;
            callback({ mensajes, respuesta });
        });
    }
}
UnidadMedidaService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UnidadMedidaService_Factory() { return new UnidadMedidaService(i0.ɵɵinject(i1.GraphQLClient)); }, token: UnidadMedidaService, providedIn: "root" });
